<template>
  <div :class="'config-group small-12 ' + optionWidthClass() +' column d-flex flex-column align-items-center'">
    <div class="config-item w-100 position-relative">
      <div class="d-flex align-items-center input-calc h-spacing-4">
        <div
            class="input-calc__container position-relative w-50 max-w-50 d-flex align-items-center flex-child-auto mb-0">
          <div class="flex-child-auto">
            <div class="config-item__info d-inline-flex">
              <label for="js-freeformat-height">{{ "freeFormatHeight"|translate }}</label>
              <Tooltip :infoText="tooltipHeight"/>
            </div>
            <input type="number" min="1" id="js-freeformat-height" name="freeformat-height"
                   :value="currentHeight" @change="checkAndUpdateHeightValue( $event )" class="text-center w-100">
          </div>
        </div>
        <div
            class="input-calc__container position-relative w-50 max-w-50 d-flex align-items-center flex-child-auto mb-0">
          <div class="flex-child-auto">
            <div class="config-item__info d-inline-flex">
              <label for="js-freeformat-width">{{ "freeFormatWidth"|translate }}</label>
              <Tooltip :infoText="tooltipWidth"/>
            </div>
            <input type="number" min="1" id="js-freeformat-width" name="freeformat-width"
                   :value="currentWidth" @change="checkAndUpdateWidthValue( $event )" class="text-center w-100">

          </div>
        </div>
      </div>
      <div v-if="option.currentInfo.msgType === 'INFO'" class="text-small mt-prj text-info d-flex line-height-12">
        <svg xmlns="http://www.w3.org/2000/svg" class="mr-2 svg-icon flex-child-fix position-relative t-1px" x="0" y="0"
             viewBox="0 0 36 36" xml:space="preserve"><path d="M36 18.01c0 9.94-8.04 17.98-17.99 17.99C8.03 36.01-.01 27.95 0 17.93 0 8.04 8.09-.01 18.02 0 27.96.01 36 8.06 36 18.01z" fill="#62b982"/>
          <path id="XMLID_1_"
                d="M14.93 26.67l-6.46-6.46a2.07 2.07 0 010-2.93 2.07 2.07 0 012.93 0l3.55 3.55 9.66-9.56c.81-.8 2.12-.8 2.93.02.8.81.8 2.12-.02 2.93L14.93 26.67z"
                fill="#fff"/></svg>
        {{ option.currentInfo.text }}
      </div>
      <div v-if="option.currentInfo.msgType === 'ERROR'" class="text-small mt-prj text-error d-flex line-height-12">
        <svg xmlns="http://www.w3.org/2000/svg" class="mr-2 svg-icon flex-child-fix position-relative t-1px"
             viewBox="0 0 36 36">
          <circle cx="18" cy="18" r="18" fill="#e94d47"/>
          <path
              d="M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z"
              fill="#fff"/>
        </svg>
        {{ option.currentInfo.text }}
      </div>
    </div>
  </div>

  <!-- </div> -->
</template>

<script>
import {OPTION_TYPE_IDS_MEDIUM_12} from "mixins/optionWidth";
import {translatePrj} from "../classes/vue-dict-filter";
import Tooltip from "./Tooltip.vue";

export const CONFIGOPTION_TYPE = "Freiformat";


export default {
  components: {Tooltip},
  props: {
    min: {
      type: Number,
      default: 1
    },
    max: Number,
    option: {},
    baseWidth: Number
  },
  inject: ['configuratorService'],
  data() {
    return {
      value: 1
    }
  },
  methods: {
    optionWidthClass() {
      if (this.option?.auspraegungen.some(v => v.name.length > 20) || OPTION_TYPE_IDS_MEDIUM_12.some(v => v == this.option.configtype)) {
        return 'medium-' + this.baseWidth * 2
      }
      return 'medium-' + this.baseWidth
    },
    hideInfoAfterTimeout() {
      if (this.option.currentInfo.msgType === "INFO") {
        let self = this;
        let afterTimeout = function () {
          self.option.currentInfo.msgType = "";
        }
        setTimeout(afterTimeout, 2000);
      }
    },
    checkAndUpdateHeightValue( event ) {
        let value = event.target.value
        let parsedHoehe = parseInt(value);
        if(isNaN(parsedHoehe)) {
          this.configuratorService.validate() // validate resets value to default
        } else {
          this.option.dynamicValues.Hoehe = parsedHoehe;
          this.configuratorService.validate()
        }
    },
    checkAndUpdateWidthValue( event ) {
      let value = event.target.value
      let parsedBreite = parseInt(value);
      if(isNaN(parsedBreite)) {
        this.configuratorService.validate() // validate resets value to default
      } else {
        this.option.dynamicValues.Breite = parsedBreite;
        this.configuratorService.validate()
      }
    },
  },

  computed: {
    currentHeight: {
      get() {
        return this.option.dynamicValues.Hoehe;
      },
      set(val) {
        this.option.dynamicValues.Hoehe = val;
        this.configuratorService.validate()
      }
    },
    currentWidth: {
      get() {
        return this.option.dynamicValues.Breite;
      },
      set(val) {
        this.option.dynamicValues.Breite = val;
        this.configuratorService.validate()
      }
    },

    msgType() {
      return this.option.currentInfo.msgType;
    },
    tooltipHeight(){
      return translatePrj('freeFormatHeightTooltip')
    },
    tooltipWidth(){
      return translatePrj('freeFormatWidthTooltip')
    },
  },
  watch: {
    msgType: {
      immediate: true,
      handler() {
        this.hideInfoAfterTimeout();
      }
    }
  }
};
</script>
